export default {
  footerLink: 'Cookie-Einstellungen',
  consentModal: {
    title: 'Wir verwenden Cookies',
    description: 'Wir verwenden nur die nötigsten Cookies, damit die Seite funktioniert, sowie optionale Cookies für Analyse und Werbung — nur mit Ihrer Zustimmung.',
    acceptAllBtn: 'Alle akzeptieren',
    acceptNecessaryBtn: 'Alle ablehnen',
    showPreferencesBtn: 'Einstellungen verwalten',
  },
  preferencesModal: {
    title: 'Cookie-Einstellungen',
    acceptAllBtn: 'Alle akzeptieren',
    acceptNecessaryBtn: 'Alle ablehnen',
    savePreferencesBtn: 'Einstellungen speichern',
    closeIconLabel: 'Schließen',
    sections: [
      {
        title: 'Notwendig',
        description: 'Diese Cookies sind für die Funktion der Seite erforderlich und können nicht deaktiviert werden.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Analyse',
        description: 'Helfen uns zu verstehen, wie die Seite genutzt wird, damit wir sie verbessern können.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Werbung',
        description: 'Werden verwendet, um Anzeigen relevanter zu machen. Nur mit Ihrer Zustimmung aktiv.',
        linkedCategory: 'ads',
      },
    ],
  },
}
